import React, { useState, useRef, useEffect, useCallback } from "react";
import "./style.scss";
import classNames from "classnames";
import ListContentItem from "../../react-components/list-content-item";
import Pagination from "../pagination";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";

const ListContent = ({ rendering, fields, lang, page }) => {
  const {
    paddingAboveTop,
    paddingAboveBottom,
    gridType,
    alignment,
    backgroundColor,
    backgroundImage,
    paginationStyle,
    headingType,
    headingBody,
    subheadingType,
    subheadingBody,
    items,
    ctaText,
    iconName,
    colorScheme,
    nuberOfRowsShownFromStart,
    extraRowsShownOnLoadMore,
    numberOfItemsInRowMobile = { value: 3 }
  } = fields;
  const numberOfPages = Math.ceil(items.length / 3);
  const isCarousel = paginationStyle && paginationStyle.fields.phrase.value === "carousel" && items.length > 3;
  const [currentPage, setCurrentPage] = useState(/^ar-/gi.test(lang) ? numberOfPages - 1 : 0);
  const [loadedItems, setLoadedItems] = useState([]);
  const [rowSize, setRowSize] = useState(3);
  const itemsContainer = useRef();

  useEffect(() => {
    calculatRowSize();
    let timeout = setTimeout(() => {
      let elem = itemsContainer.current;
      if (isCarousel) {
        elem.scrollLeft = (elem.clientWidth + 30) * currentPage;
      }
      isCarousel && goToPage({ target: { id: currentPage } });
      if (lang === 'ar-ae') {
        elem.scrollLeft = elem.scrollWidth;
      }
    }, 1000 / 24);
    return () => {
      clearTimeout(timeout);
      timeout = null;
    };
  }, [page]);

  const handleResize = useCallback(() => {
    calculatRowSize();
  }, []);
  // Add event listeners for resize and scroll
  useEffect(() => {
    global.addEventListener("resize", handleResize);
    return () => {
      global.removeEventListener("resize", handleResize, false);
    };
  }, [handleResize]);

  useEffect(() => {
    if (paginationStyle.fields.phrase.value === "loadMoreButton") {
      setLoadedItems(items.slice(0, nuberOfRowsShownFromStart.value * rowSize));
    } else {
      setLoadedItems(items);
    }
    // console.log(items.length)
  }, [rowSize,page]);

  const calculatRowSize = () => {
    //desktop
    if (window.innerWidth >= 992) {
      setRowSize(4);
    } else if (window.innerWidth <= 767) {
      setRowSize(numberOfItemsInRowMobile.value);
    }
  };

  const sideScroll = (element, direction, speed, distance, step) => {
    let scrollAmount = 0;
    var slideTimer = setInterval(function() {
      if (direction === "left") {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  };

  const goForward = (evt, pages = 1) => {
    setCurrentPage(currentPage + pages);
    let elem = itemsContainer.current;
    let amount = (elem.clientWidth + 30) * pages;
    let step = amount / 10;

    sideScroll(elem, "right", 50, amount, step);
  };

  const goBack = (evt, pages = 1) => {
    setCurrentPage(currentPage - pages);
    let elem = itemsContainer.current;
    let amount = (elem.clientWidth + 30) * pages;
    let step = amount / 10;
    sideScroll(elem, "left", 50, amount, step);
  };

  const goToPage = event => {
    let targetPage = event.target.id;
    console.log("targetPage", targetPage);
    if (targetPage === currentPage) {
      return;
    }
    if (targetPage > currentPage) {
      //go forrward

      goForward(event, targetPage - currentPage);
      return;
    }
    if (targetPage < currentPage) {
      // go back
      goBack(event, currentPage - targetPage);
      return;
    }

    setCurrentPage(targetPage);
  };

  const handleShowMore = event => {
    setLoadedItems(items.slice(0, nuberOfRowsShownFromStart.value * rowSize + extraRowsShownOnLoadMore.value * rowSize * (currentPage + 1)));

    setCurrentPage(currentPage + 1);
  };

  const listContent = () => {
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default";
    const listContentClasses = classNames(
      "list-content",
      "padding-top-" + top,
      "padding-bottom-" + bottom,
      {
        grid: (gridType && gridType.fields.phrase.value) === "normal"
      },
      {
        "grid-story": (gridType && gridType.fields.phrase.value) === "story"
      }
    );

    const titleClasses = classNames("title", "show-on-scroll", {
      center: (alignment && alignment.fields.phrase.value) === "center"
    });

    let backgroundStyle = {};
    if (backgroundColor) {
      backgroundStyle = {
        background: backgroundColor.fields.phrase.value
      };
    }

    if (backgroundImage && backgroundImage.value.src) {
      backgroundStyle = {
        backgroundImage: `url(${backgroundImage.value.src})`
      };
    }

    const itemsContaninerClasses = classNames(
      "items-container",
      "grid",
      "full-width",
      paginationStyle.fields.phrase.value,
      {
        "show-on-scroll": paginationStyle.fields.phrase.value !== "loadMoreButton"
      },
      {
        "two-items": items.length <= 2 && paginationStyle.fields.phrase.value !== "loadMoreButton"
      },
      {
        "three-items": items.length === 3 && paginationStyle.fields.phrase.value !== "loadMoreButton"
      },
      {
        "many-items": items.length > 3 && paginationStyle.fields.phrase.value !== "loadMoreButton"
      }
    );

    return (
      <div className={listContentClasses} style={backgroundStyle} datasourceid={rendering.dataSource}>
        {headingBody && headingBody.value && (
          <Heading
            {...{
              type: headingType,
              html: headingBody
            }}
            typographyClass="type-h1"
            className={titleClasses}
          />
        )}

        {subheadingBody && subheadingBody.value && (
          <Heading
            className="sub-title"
            {...{
              type: subheadingType,
              html: subheadingBody
            }}
            typographyClass="type-h3"
          />
        )}
        <div className={itemsContaninerClasses} ref={itemsContainer} id="itemsContainer">
          {loadedItems.map((item, index) => (
            <ListContentItem {...{ ...item, index: index }} key={index} />
          ))}
        </div>

        {isCarousel && (
          <Pagination
            pagination={{
              currentPage,
              numberOfPages
            }}
            onDotClicked={evt => goToPage(evt)}
            onClickedBack={evt => goBack(evt)}
            onClickedForward={evt => goForward(evt)}
          />
        )}
        {paginationStyle.fields.phrase.value === "loadMoreButton" && nuberOfRowsShownFromStart.value * rowSize + currentPage * rowSize < items.length && (
          <div className={"show-more"}>
            <PrimaryButton
              {...{
                colorScheme,
                iconName,
                link: {
                  value: {
                    text: ctaText.value
                  }
                },
                callback: evt => handleShowMore(evt)
              }}
            />
          </div>
        )}
      </div>
    );
  };

  if ((gridType && gridType.fields.phrase.value) === "story") {
    return <div className={"grid"}>{listContent()}</div>;
  } else {
    return listContent();
  }
};

export default ListContent;
